(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rs-header"]) return;
  try {
    
import('@shopify/events').then(({ StandardEvents }) => {
  document.addEventListener(StandardEvents.cartLinesUpdate, (event) => {
    event.promise?.then(({ cart, detail }) => {
      const count = cart?.totalQuantity ?? detail?.itemCount;
      if (!Number.isInteger(count) || count < 0) return;
      document.querySelectorAll('.rs-bag-count').forEach((element) => {
        element.textContent = String(count);
      });
    }).catch(() => {});
  });
});

  } catch(e) { console.error(e); }
})();
})();
